import React, { Fragment } from 'react';

import { ListGroup, Accordion, Card } from 'react-bootstrap';
import { MatchSegmentStats, Stat } from '../../models/interfaces/Stat';
import { MatchStatus } from '../../models/interfaces/Match';

import StatView from '../stats/StatView';
import MatchStatListAccordionHeader from './modules/MatchStatListAccordionHeader';
import styled from 'styled-components';
import { parseTeamColor } from '../../helpers/parseTeamColor';
import { isMatchEntry } from '../../models/interfaces/MatchEntry';
import { isRosterEntry } from '../../models/interfaces/RosterEntry';

function boxShadowString(color: string, light: number | boolean): string {
    if (light === null) return ';';
    return `box-shadow: inset ${light === 1 || light === true ? '' : '-'}0.3rem 0 0 0 ${color};`;
}

const StyledListGroupItem = styled(ListGroup.Item)<{ $color: string; $light: number | boolean }>`
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    ${({ $color, $light }) => boxShadowString($color, $light)}
`;

interface Props {
    matchStatsList: MatchSegmentStats[];
    shouldDisplayStat: (stat: Stat) => boolean;
    currentMatchStatus: number;
}

export function MatchStatList({ matchStatsList, shouldDisplayStat, currentMatchStatus }: Props) {
    return (
        <>
            {matchStatsList.map((matchStats) => {
                const showTimeStamp =
                    currentMatchStatus === MatchStatus.inProgress &&
                    matchStats.matchSegment.databaseValue ===
                        matchStatsList[0].matchSegment.databaseValue;
                return (
                    <Accordion
                        //Accordion activeKey & eventKey needs to be a string
                        defaultActiveKey={matchStatsList[0].matchSegment.databaseValue + ''}
                        key={matchStats.matchSegment.databaseValue}
                        style={{ paddingBottom: '8px' }}
                    >
                        <Card>
                            <MatchStatListAccordionHeader
                                displayName={matchStats.matchSegment.displayName}
                                showTimeStamp={showTimeStamp}
                                eventKey={matchStats.matchSegment.databaseValue + ''}
                                initialExpandedState={
                                    matchStatsList[0].matchSegment.databaseValue ===
                                    matchStats.matchSegment.databaseValue
                                }
                            />
                            {matchStats.stats
                                .filter((stat) => shouldDisplayStat(stat))
                                .map((stat, idx) => {
                                    return (
                                        <Accordion.Collapse
                                            key={stat.id}
                                            eventKey={matchStats.matchSegment.databaseValue + ''}
                                        >
                                            <StyledListGroupItem
                                                key={stat.id}
                                                $color={
                                                    isMatchEntry(stat.performer)
                                                        ? parseTeamColor(stat.performer.color)
                                                        : isRosterEntry(stat.performer)
                                                        ? parseTeamColor(stat.performer.team.color)
                                                        : ''
                                                }
                                                $light={
                                                    isMatchEntry(stat.performer)
                                                        ? stat.performer.id ===
                                                          stat.match.lightCapTeam.id
                                                        : isRosterEntry(stat.performer)
                                                        ? stat.performer.team.id ===
                                                          stat.match.lightCapTeam.id
                                                        : 0
                                                }
                                            >
                                                <StatView stat={stat} />
                                            </StyledListGroupItem>
                                        </Accordion.Collapse>
                                    );
                                })}
                        </Card>
                    </Accordion>
                );
            })}
        </>
    );
}
